import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { FilterTagsComponent } from './filter-tags/filter-tags.component';
import { FilterUsersComponent } from './filter-users/filter-users.component';
import { SiteFilterDropdownComponent } from './site-filter-dropdown/site-filter-dropdown.component';
import { SiteFilterComponent } from './site-filter.component';

import { SitePointFilterService } from 'src/app/project/modules/filters/site-point-filter.service';

import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ButtonModule } from '../../components/button/button.module';
import { FilterFieldNumberInputModule } from '../../components/filter-field-numbers-input/filter-field-number-input.module';
import { IconModule } from '../../components/icon/icon-module';
import { CheckboxModule } from '../../components/input/checkbox/checkbox.module';
import { SelectModule } from '../../components/input/select/select.module';
import { TagModule } from '../../components/tag/tag.module';
import { ToggleModule } from '../../components/toggle/toggle.module';
import { UserPickerModule } from '../../components/user-picker/user-picker.module';
import { FocusModule } from '../../directives/focus/focus.module';
import { ImagesFallbackModule } from '../../directives/images-fallback/images-fallback.module';
import { OnRenderedModule } from '../../directives/on-rendered/on-rendered.module';
import { SecureSrcModule } from '../../directives/secure-src/secure-src.module';
import { TooltipsModule } from '../../features/tooltip/tooltips.module';
import { FiltersAdvancedModule } from '../filters-advanced/filters-advanced.module';
import { LayoutModule } from '../layout/layout.module';
import { SavedViewsModule } from '../saved-views/saved-views.module';
import { TagsModule } from '../tags/tags.module';
import { FilterContainerComponent } from './filter-container/filter-container.component';
import { QuickFiltersComponent } from './quick-filters/quick-filters.component';
import { DataTestModule } from 'src/app/project/directives/data-test/data-test.module';
import { ToggleButtonModule } from '../../components/toggle-button/toggle-button.module';
import { GroupedMultiSelectDropdownModule } from '../../components/input/grouped-multi-select-dropdown/grouped-multi-select-dropdown.module';
import { FilterFieldAccountSitesModule } from './filter-fields/filter-field-account-sites/filter-field-account-sites.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    LayoutModule,
    SelectModule,
    TagsModule,
    CheckboxModule,
    TooltipsModule,
    FocusModule,
    ImagesFallbackModule,
    OnRenderedModule,
    ToggleModule,
    PipesModule,
    SecureSrcModule,
    TagModule,
    IconModule,
    FiltersAdvancedModule,
    UserPickerModule,
    SavedViewsModule,
    FilterFieldNumberInputModule,
    DataTestModule,
    ToggleButtonModule,
    GroupedMultiSelectDropdownModule,
    FilterFieldAccountSitesModule,
  ],
  exports: [
    FilterDropdownComponent,
    SiteFilterDropdownComponent,
    SiteFilterComponent,
    FilterContainerComponent,
  ],
  providers: [SitePointFilterService],
  declarations: [
    FilterContainerComponent,
    SiteFilterComponent,
    SiteFilterDropdownComponent,
    FilterTagsComponent,
    FilterUsersComponent,
    FilterDropdownComponent,
    QuickFiltersComponent,
  ],
})
export class FiltersModule {}
